// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"Clock_buttonsContainer__kHbOy","clock":"Clock_clock__lKTS3","watch":"Clock_watch__d5TKv","more":"Clock_more__sTsRj"};